import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";
import { KontakDaruratByIDResponse } from "../../../../models/KontakDarurat";

export const allKontakDaruratKey = "all-kontak-darurat-key";

export async function kontakDarurat(
    ID: number
): Promise<KontakDaruratByIDResponse> {
    const res = await ApiClient.get(
        `/EmergencyContact/${ID}`
    );
    return res.data;
}

export const useFetchKontakDarurat = mutationWrapper(kontakDarurat);
